import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    return {
        container: {
            padding: '0px 24px',
            display: 'flex',
            justifyContent: 'space-between'
            //border: '1px solid red'
        },
        flex1: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        },
        mainCotainer: {
            position: 'relative',
        },
        boxUser: (haveMax: boolean, expanded: boolean, isEdit: boolean) => ({
            marginTop: 2,
            marginBottom: 2,
            padding: '4px',
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1,
            ...(haveMax && {
                maxHeight: expanded ? '120px' : '40px',
                overflowY: expanded ? 'scroll' : 'hidden',
            }),
            overflowX: 'hidden',
            scrollbarWidth: expanded ? 'auto' : 'none',
            msOverflowStyle: expanded ? 'auto' : 'none', 
            '&::-webkit-scrollbar': {
                display: expanded ? 'auto' : 'none', 
            },
            width:'100%'
        }),
        userContainer: {
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            color: colors.color13,
            '& .MuiTypography-root': {
                fontSize: '14px'
            },
            '& .MuiSvgIcon-root': {
                fontSize: '20px'
            },
            '&.MuiPaper-root': {
                margin : '0px',
                padinTop: '5px',
                paddingBottom: '5px'
            }
        },
        userBox: {
            border: `1px solid ${colors.color32}`,
            borderRadius: 1
        },
        userName: {
            display: 'inline-block',
            fontWeight: 'bold'
            //maxWidth: '120px',
        },
        buton: {
            textDecoration: 'underline',
            color: colors.color10,
            fontSize: '12px',
            '& .MuiSvgIcon-root': {
                fontSize: '14px'
            },
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        containerButton: {
            display: 'flex',
            justifyContent: ' end',
            position: 'absolute',
            right: '0px',
            bottom: '-40px'
        },
        buttonClose: {
            '&.MuiIconButton-root': {
                padding: '0px'
            }
        },
        addButton: {
            color: colors.color1,
            '&.MuiIconButton-root': {
                padding: '0px'
            }
        }
    }
}

export { useStyles }
